import React from 'react';
import PropTypes from 'prop-types';

const BackArrow = ({ color, size, title }) => {
  return (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 1000 1000"
      x="0px"
      y="0px"
      width={size || '40px'}
      role="img"
    >
      <title>{title}</title>
      <g>
        <path d="M219.01,728.52c8.44,10.1,23.46,11.46,33.57,3.04c10.1-8.44,11.46-23.46,3.04-33.57c-0.92-1.1-1.94-2.12-3.04-3.04L81.21,523.36h896c13.19-0.7,23.33-11.96,22.63-25.15c0-0.05-0.01-0.1-0.01-0.15c-0.65-12.22-10.41-21.98-22.62-22.62H81.18l171.66-171.16c8.96-9.4,8.96-24.18,0-33.57c-9.26-9.26-24.27-9.27-33.53-0.01c0,0-0.01,0.01-0.01,0.01l0,0L7.02,482.99c-9.27,8.93-9.55,23.69-0.61,32.96l0.61,0.61L219.01,728.52z" />
      </g>
    </svg>
  );
};

export default BackArrow;

BackArrow.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string,
};
